<form [formGroup]="form" (ngSubmit)="save()">
    <h1 mat-dialog-title>Seleccionar coordinador</h1>
    <div mat-dialog-content>
        <mat-form-field class="full-width">
            <input type="text" matInput placeholder="Profesional" formControlName="physician" [matAutocomplete]="autPhysician">
            <mat-autocomplete #autPhysician="matAutocomplete" [displayWith]="filterCompletePhysicianFilter.displayFn">
                <mat-option *ngFor="let physician of filterCompletePhysicianFilterOptions | async" [value]="physician">
                    {{ physician.Name }}
                </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="f.physician.errors && f.physician.errors.required">
                Seleccione un profesional
            </mat-error>
        </mat-form-field>
    </div>
    <div class="clearfix">
        <div class="pull-right">
            <button mat-button type="submit">Guardar</button>
            <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
        </div>
    </div>
</form>